<ng-container *ngIf="data && data.status">
  <div class="screen" [ngClass]="!data.status ? 'show' : ''">
    <mat-spinner [diameter]="25"></mat-spinner>
    <div class="title">{{data.message}}</div>
    <div class="cancel" (click)="cancel()">Отменить</div>
  </div>
</ng-container>
